// Copyright (c) Microsoft Corporation. All rights reserved.

import "../App.css";

import React from "react";

// Sample TOU page.
class SampleAppTermsOfUse extends React.Component {
  render() {
    return (
      <div>
        <h1>Services Agreement</h1>
        <br />
        <a
          className="App-link"
          href="https://www.microsoft.com/en-us/servicesagreement"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of use.
        </a>
      </div>
    );
  }
}

export default SampleAppTermsOfUse;
